export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/traveler-right-detail.6c5604db-bf1628.svg";